import api from "../../../../services/api";

export type Temperatura = "" | "Frio" | "Morno" | "Quente";

export type Props = {
  idCard: string;
  temperatura: Temperatura;
  onChange?: () => Promise<void>;
};

export async function AlterarTemp({
  idCard,
  temperatura,
}: Props): Promise<number> {
  try {
    const response = await api.post("/csp/representante/temperatura", {
      idCard,
      temperatura,
    });
    return response.status;
  } catch (error) {
    console.error(error);
    return 500;
  }
}
